import React , {useState} from 'react'
import {useHistory} from "react-router-dom"
import "./enteral.css";
import Header from "./Header"
import Footer from "./Footer"
import { Icon, InlineIcon } from '@iconify/react';
import calculatorIcon from '@iconify-icons/entypo/calculator';
import { round } from 'mathjs' 

function FeedingRate() {
    let history = useHistory();

    //change text color to blue when tapped

    //feed
    const [selectBMilk, setSelectBmilk] = useState(false)
    const [selectP22, setSelectP22] = useState(false)
    const [selectP24, setSelectP24] = useState(false)

    //hmf
    const [selectNo, setSelectNo] = useState(false)
    const [selectR25, setSelectR25] = useState(false)
    const [selectR50, setSelectR50] = useState(false)

    var weight = localStorage.getItem("current weight")
    const [feedRate, setFeedRate] = useState("");
    const [whey, setWhey] = useState("");

    const [bmilk, setBmilk] =  useState("");
    const [p22, setP22] = useState("");
    const [p24, setP24] = useState("");
    const [no, setNo] = useState("");
    const [ratio25, setRatio25] = useState("");
    const [ratio50, setRatio50] = useState("");

    var weightCalc = parseFloat(weight)
    var weightCalc1 = weightCalc.toFixed(2)
    var totalVolC = weightCalc1 * feedRate
    var totalVol = totalVolC.toFixed(1)




    var wheyproteinE  = round(whey * 4.15,2)
    localStorage.setItem("wheyproteinE",wheyproteinE)
  

    var wheyproteinP  = round(whey * 0.798,2)
    localStorage.setItem("wheyproteinP",wheyproteinP)

      

    const calculate = () => {
        console.log("calculate")
        history.push("/calculate-fr")
        
    }


    const handleFeedingRate = (event) => {
        setFeedRate(event.target.value);
        localStorage.setItem("feeding rate", event.target.value);
   
      };

      const handleWhey = (event) => {
        setWhey(event.target.value);
        localStorage.setItem("whey protein", event.target.value);
        
      };


      const handleBmilk = (event) => {
        setBmilk(event.target.value);
        setSelectBmilk(true)
        setSelectP22(false)
        setSelectP24(false)
        localStorage.setItem("Type of feed", "Breastmilk");
         var feedE = (totalVol * 0.75)
        localStorage.setItem("feedE" , feedE)
        var feedP = (totalVol * 0.013)
        localStorage.setItem("feedP" , feedP)
        
      }

      const handleP22 =(event) => {
        setP22(event.target.value);
        setSelectBmilk(false)
        setSelectP22(true)
        setSelectP24(false)
        localStorage.setItem("Type of feed", "P22");
         var feedE = (totalVol * 0.74)
        localStorage.setItem("feedE" , feedE)
        var feedP = (totalVol * 0.021)
        localStorage.setItem("feedP" , feedP)
        
      }

      const handleP24 = (event) => {
        setP24(event.target.value);
        setSelectBmilk(false)
        setSelectP22(false)
        setSelectP24(true)
        localStorage.setItem("Type of feed", "P24");
         var feedE = (totalVol * 0.81)
        localStorage.setItem("feedE" , feedE)
        var feedP = (totalVol * 0.024)
        localStorage.setItem("feedP" , feedP)
        
      }

      const handleNo = (event) => {
        setNo(event.target.value);
        setSelectNo(true)
        setSelectR25(false)
        setSelectR50(false)
        localStorage.setItem("HMF", "No");
         var hmfE = totalVol * 0
        localStorage.setItem("hmfE" , hmfE)
        var hmfP = totalVol * 0
        localStorage.setItem("hmfP" , hmfP)
        
      }

      const handleRatio25 = (event) => {
        setRatio25(event.target.value);
        setSelectNo(false)
        setSelectR25(true)
        setSelectR50(false)
        localStorage.setItem("HMF", "1:25");
        var hmfE = (totalVol * 0.14)
        localStorage.setItem("hmfE" , hmfE)
        var hmfP = (totalVol * 0.01)
        localStorage.setItem("hmfP" , hmfP)
        
      }

      const handleRatio50 = (event) => {
        setRatio50(event.target.value);
        setSelectNo(false)
        setSelectR25(false)
        setSelectR50(true)
        localStorage.setItem("HMF", "1:50");
        var hmfE = (totalVol * 0.07)
        localStorage.setItem("hmfE" , hmfE)
        var hmfP = (totalVol * 0.005)
        localStorage.setItem("hmfP" , hmfP)
        
      }



    return (
        <div className="row">
        <div className="col-md-12">
        <div className= "enteral__page">
        <Header/>
        <div className="enteral__content">
        <form onSubmit = {calculate}>
            <p><strong>Please insert data in the cells.</strong></p>
         <label><strong>Current Weight:</strong> <div className = "weight__button"> {weight} </div> </label>
            <div className = "feeding__rate">
                <label><strong>Feeding Rate (ml/kg/day)</strong> <input step="any" required  value = {feedRate} onChange = {handleFeedingRate} className = "input__feedingrate" type = "number"  pattern = "^(\d*\.)?\d+$" size="7" placeholder="0.0"/></label> 
                <div className = "type__of__feed">
                    <label><strong>Type of feed</strong></label>
                    <p>
                        <span onClick = {handleBmilk} value ={bmilk} className  = {selectBMilk ? "breastmilk__select1" : "breastmilk__select"}>
                            <div className = "breastmilk__word">Breastmilk</div>
                        </span> 
                        <span onClick = {handleP22} value ={p22} className = {selectP22 ? "breastmilk__select1" : "breastmilk__select"}>
                        <div className = "breastmilk__word">P22</div>
                            </span>
                         <span onClick = {handleP24} value ={p24} className = {selectP24 ? "breastmilk__select1" : "breastmilk__select"}>
                         <div className = "breastmilk__word">P24</div>
                             </span>
                    </p>
                    <label> <strong>HMF</strong> </label>
                        <p> 
                            <span required onClick = {handleNo} value ={no} className = {selectNo ? "hmf__select1" : "hmf__select"}>
                                <div className = "breastmilk__word">NO</div>
                                </span>
                                 <span onClick = {handleRatio25} value ={ratio25} className = {selectR25 ? "hmf__select1" : "hmf__select"}>
                                 <div className = "breastmilk__word">1:25</div>
                                     </span> 
                            <span required onClick = {handleRatio50} value ={ratio50} className ={selectR50 ? "hmf__select1" : "hmf__select"}>
                            <div className = "breastmilk__word">1:50</div>
                                </span>
                        </p>
                    <label><strong>Whey Protein (g/day)</strong> <input step="any" required className = "whey__protein__FR" value = {whey} onChange={handleWhey} size="7" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder="0.0"/></label>
                    <div className = "total__feedingrate">
    <label><strong>Total Volume of Feeds (ml)</strong> <div className = "total__volumefeed">{totalVol}</div></label>
                    </div>
                    <p>
                        <button className = "calculate__fr" onSubmit = {calculate}>
                        <Icon icon={calculatorIcon} />  Calculate
                          </button>
                    </p>
           </div>
           </div>
           </form>
           </div>
        </div>
        </div>
        </div>
    )
}

export default FeedingRate
